<template>
  <div
    class="range_picker_container d-flex-column justify-start align-start gap-18"
  >
    <div class="d-flex-row justify-start">
      <Wins
        v-if="
          type === 'wins' ||
          type === 'games-other' ||
          type === 'games' ||
          type === 'rounds' ||
          type === 'current_bp' ||
          type === 'desired_bp'
        "
      />
      <GamesOther
        v-if="
          type === 'games-learning' ||
          type === 'hours-learning' ||
          type === 'vod-learning'
        "
      />
      <FortniteWins
        v-if="
          type === 'fort-games-learning' ||
          type === 'fort-hours-learning' ||
          type === 'fort-vod-learning' ||
          type === 'current_mmr' ||
          type === 'desired_mmr'
        "
      />
      <HoodedBooster v-if="type === 'boosters'" />
      <WinsOver v-if="type === 'wins-over' || type === 'games-over'" />
      <WinsDota
        v-if="
          type === 'wins-dota' ||
          type === 'callibration-dota' ||
          type === 'games-dota'
        "
      />
      <WinsDota v-if="type === 'wins-val'" />

      <div class="d-flex-column justify-start align-start gap-0">
        <h4 class="t-white font-family-1 title-h5 f-w-600">
          {{ title }}
        </h4>
        <h4 class="regular-m font-family-2 t-grey">
          {{ description }}
        </h4>
      </div>
    </div>
    <range-slider
      v-model="range"
      :min="min"
      :max="max"
      :default-value="defaultRange"
    />
  </div>
</template>

<script>
import Wins from "~/components/icons/packs/Wins.vue";
import RangeSlider from "~/components/custom/RangeValueSlider.vue";
import HoodedBooster from "~/components/icons/packs/HoodedBooster.vue";
import WinsOver from "~/components/icons/packs/WinsOver.vue";
import WinsDota from "~/components/icons/packs/WinsDota.vue";
import WinsVal from "~/components/icons/packs/WinsVal.vue";
import GamesOther from "~/components/icons/packs/GamesOther.vue";
import FortniteWins from "~/components/icons/packs/FortniteWins.vue";
export default {
  data() {
    return {
      range: 1,
    };
  },
  components: {
    Wins,
    RangeSlider,
    HoodedBooster,
    WinsOver,
    WinsDota,
    WinsVal,
    GamesOther,
    FortniteWins,
  },
  computed: {},
  props: {
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "wins",
    },
    min: {
      type: Number,
      default: 1,
    },
    max: {
      type: Number,
      default: 10,
    },
    defaultRange: {
      type: Number,
      default: 1,
    },
  },
  beforeMount() {
    this.range = this.defaultRange;
  },
  watch: {
    range() {
      if (
        this.type === "games" ||
        this.type === "games-other" ||
        this.type === "games-learning" ||
        this.type === "games-dota" ||
        this.type === "fort-games-learning" ||
        this.type === "games-over" ||
        this.type === "callibration-dota"
      ) {
        this.checkoutStore.setDetails({
          ...this.checkoutStore.getDetails,
          numberOfGames: parseInt(this.range),
        });
      }
      if (
        this.type === "wins" ||
        this.type === "wins-over" ||
        this.type === "wins-val" ||
        this.type === "wins-dota"
      ) {
        this.checkoutStore.setDetails({
          ...this.checkoutStore.getDetails,
          numberOfWins: parseInt(this.range),
        });
      }
      if (this.type === "boosters") {
        this.checkoutStore.setDetails({
          ...this.checkoutStore.getDetails,
          numberOfBoosters: parseInt(this.range),
        });
      }
      if (
        this.type === "hours-learning" ||
        this.type === "fort-hours-learning"
      ) {
        this.checkoutStore.setDetails({
          ...this.checkoutStore.getDetails,
          numberOfHours: parseInt(this.range),
        });
      }
      if (this.type === "vod-learning" || this.type === "fort-vod-learning") {
        this.checkoutStore.setDetails({
          ...this.checkoutStore.getDetails,
          vodReviews: parseInt(this.range),
        });
      }

      if (this.type === "current_mmr") {
        this.checkoutStore.setDetails({
          ...this.checkoutStore.getDetails,
          currentMmr: parseInt(this.range),
        });
      }
      if (this.type === "desired_mmr") {
        this.checkoutStore.setDetails({
          ...this.checkoutStore.getDetails,
          desiredMmr: parseInt(this.range),
        });
      }
      if (this.type === "current_bp") {
        this.checkoutStore.setDetails({
          ...this.checkoutStore.getDetails,
          currentBp: parseInt(this.range),
        });
      }

      if (this.type === "desired_bp") {
        this.checkoutStore.setDetails({
          ...this.checkoutStore.getDetails,
          desiredBp: parseInt(this.range),
        });
      }

      if (this.type === "rounds") {
        this.checkoutStore.setDetails({
          ...this.checkoutStore.getDetails,
          numberOfRounds: parseInt(this.range),
        });
      }
    },

    getDetails: {
      handler() {
        if (this.type === "desired_mmr") {
          if (
            this.checkoutStore.getDetails.currentMmr >=
            this.checkoutStore.getDetails.desiredMmr
          ) {
            this.checkoutStore.setDetails({
              ...this.checkoutStore.getDetails,
              desiredMmr: this.checkoutStore.getDetails.currentMmr + 1,
            });
          }
        }
        if (this.type === "desired_bp") {
          if (
            this.checkoutStore.getDetails.currentBp >=
            this.checkoutStore.getDetails.desiredBp
          ) {
            this.checkoutStore.setDetails({
              ...this.checkoutStore.getDetails,
              desiredBp: this.checkoutStore.getDetails.currentBp + 1,
            });
          }
        }
      },
      deep: true,
    },
    "checkoutStore.getDetails.desiredMmr"() {
      if (this.type === "desired_mmr") {
        if (this.checkoutStore.getDetails.desiredMmr !== this.range) {
          this.range = this.checkoutStore.getDetails.desiredMmr;
        }
      }
    },
    "checkoutStore.getDetails.desiredBp"() {
      if (this.type === "desired_bp") {
        if (this.checkoutStore.getDetails.desiredBp !== this.range) {
          this.range = this.checkoutStore.getDetails.desiredBp;
        }
      }
    },
  },

  setup() {
    const checkoutStore = useCheckoutStore();

    return { checkoutStore, getDetails: checkoutStore.getDetails };
  },
};
</script>
